import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getFertilizerPlotlistData, submitFertilizerPlotlistData } from '../../../../../actions/carbonfootprint';
import { FertilizerLoadingSpinner } from '../../dashboard/shared-components/GraphLoadingSpinner';
import { Box, Typography } from '@mui/material';

export default function FertilizerPlotListTable({ year, groupId }) {
    const dispatch = useDispatch()
    const [fertilizerPlotlistState, setFertilizerPlotlistState] = useState([])
    const [fertilizerAmountAppliedTotals, setFertilizerAmountAppliedTotals] = useState([])
    const loading = useSelector((state) => (state.carbonfootprint.loading))
    const fertilizerPlotlistData = useSelector((state) => (state.carbonfootprint.fertilizerPlotlistData))

    useEffect(() => {
        dispatch(getFertilizerPlotlistData(groupId, year))
    }, [year, groupId, dispatch])

    useEffect(() => {
        setFertilizerPlotlistState(fertilizerPlotlistData?.data?.rows.map((row) => {
            return {
                plotlist: row.plotlist,
                fertilizers: row.fertilizers.map((fert) => ({ ...fert, dirty: false }))
            }
        }))
        setFertilizerAmountAppliedTotals(fertilizerPlotlistData?.fertilizerTotals)
    }, [dispatch, fertilizerPlotlistData])

    const handleApplicationRateChange = (e, plotlistId, fertiliserId) => {
        setFertilizerPlotlistState((prevState => prevState.map((plotlistData) => {
            if (plotlistData.plotlist.id === plotlistId) {
                return {
                    plotlist: { ...plotlistData.plotlist, dirty: true },
                    fertilizers: plotlistData.fertilizers.map((fert) => {
                        if (fert.fertilizerId === fertiliserId) {
                            return {
                                ...fert,
                                rate: e.target.value,
                                dirty: true
                            }
                        }
                        return fert
                    })
                }
            }
            return plotlistData
        })))
    }

    const handleDataSubmission = () => {
        // const dirtyData = fertilizerPlotlistState.filter((data) => data.plotlist.dirty)
        //     .map(data => ({
        //         plotlist: data.plotlist,
        //         fertilizers: data.fertilizers.filter(fert => fert.dirty)
        //     }))
        dispatch(submitFertilizerPlotlistData(
            fertilizerPlotlistState.filter((data) => data.plotlist.dirty)
                .map(data => ({
                    plotlist: data.plotlist,
                    fertilizers: data.fertilizers.filter(fert => fert.dirty)
                })), groupId, year)).then(() => {
                    dispatch(getFertilizerPlotlistData(groupId, year))
                })
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h5'>Fertiliser Plotlist Applications</Typography>
            {loading
                ? <FertilizerLoadingSpinner />
                : <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <TableContainer component={Paper} sx={{ width: '100%' }} >

                            <Table sx={{ minWidth: '100%', width: '100%' }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell size="small" align="left">Block Name</TableCell>
                                        {/* <TableCell align="left">Official Land Number</TableCell> */}
                                        <TableCell size="small" align="left">Hectares</TableCell>
                                        <TableCell size="small" align="left">Primary Crop</TableCell>
                                        {fertilizerPlotlistData?.data?.fertilizerHeader.map((fertilizer, index) => (
                                            <TableCell key={index} align="left">
                                                {fertilizer?.productName}<br />
                                                <b style={{ color: "darkblue" }}>({fertilizer.applicationRateUnit})</b>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fertilizerPlotlistState?.map((data) => (
                                        <TableRow
                                            key={data?.plotlist?.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell size="small" align="left">{`${data?.plotlist?.block_name} - ${data?.plotlist?.official_land_num}`}</TableCell>
                                            <TableCell size="small" align="left">{data?.plotlist?.hectares}</TableCell>
                                            <TableCell size="small" align="left">{data?.plotlist?.primary_crop}</TableCell>
                                            {data?.fertilizers?.map((fertilizer, index) => (
                                                <TableCell size="small" key={index} align="left" sx={{ padding: '3px' }}>
                                                    <TextField
                                                        fullWidth
                                                        name={'application rate'}
                                                        label={''}
                                                        value={!!fertilizer.rate ? fertilizer.rate : null}
                                                        onChange={
                                                            (e) => handleApplicationRateChange(e, data?.plotlist.id, fertilizer.fertilizerId)
                                                        }
                                                    />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Button sx={{ width: 'fit-content' }} variant="contained" onClick={handleDataSubmission}>Submit data</Button>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant='h5'>Fertiliser Applied</Typography>
                        <TableContainer component={Paper} sx={{ width: '100%' }} >
                            <Table sx={{ minWidth: '100%', width: '100%' }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Fertiliser</TableCell>
                                        <TableCell align="left">Application Rate Unit</TableCell>
                                        <TableCell align="left">Total Applied</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fertilizerAmountAppliedTotals?.map((fertilizer, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell align="left">{fertilizer.productName}</TableCell>
                                            <TableCell align="left">{fertilizer.applicationRateUnit}</TableCell>
                                            <TableCell align="left">
                                                {`${String(fertilizer.totalApplied.toFixed(2))} 
                                                    ${fertilizer.applicationRateUnit === 'kg/ha'
                                                        ? 'kg'
                                                        : fertilizer.applicationRateUnit === 'L/ha'
                                                            ? 'L'
                                                            : ''}`}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            }
        </Box>
    );
}
